import { render } from "./DashboardCampaignTable.vue?vue&type=template&id=507c0368&scoped=true"
import script from "./DashboardCampaignTable.vue?vue&type=script&lang=js"
export * from "./DashboardCampaignTable.vue?vue&type=script&lang=js"

import "./DashboardCampaignTable.vue?vue&type=style&index=0&id=507c0368&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507c0368"]])

export default __exports__